// extracted by mini-css-extract-plugin
export default {"showMoreContainer":"reviewsLevelTravel-module__showMoreContainer__DJAHu","showMoreLinkButton":"reviewsLevelTravel-module__showMoreLinkButton__xCojT"};